/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { ID, WithVersion } from '@gh/common-shared-data';
import { createEnum, EnumSet, WithOptimisticLock } from '@gh/core-data';

export const TOP_CODE_CONTRACT_PRICE = 'ContractPrice';

export const GtoStyle = createEnum('GTO_STYLE', {
  NotAvailable: '0',
  Solid: '1',
  Clear: '2',
  Horizontal: '3',
  Vertical: '4',
  DiagonalOne: '5',
  DiagonalTwo: '6',
  Cross: '7',
  DiagCross: '8',
});
export type GtoStyle = EnumSet<typeof GtoStyle>;

export const GtoUom = createEnum('GTO_UOM', {
  Millimeters: 'MM',
  Meters: 'M',
  MetersSquare: 'M2',
  Feets: 'FT',
  FeetsSquare: 'FT2',
  Count: 'COUNT',
  Price: '$',
  Other: 'OTHER',
  NotAvailable: 'NA',
});
export type GtoUom = EnumSet<typeof GtoUom>;

export type TakeOffParamDto = WithOptimisticLock<WithVersion<{
  takeOffParamId: ID;
  code: string;
  isActive: boolean;
  isSystem: boolean;
  gtoUom?: GtoUom | null;
  gtoStyle?: GtoStyle | null;
  gtoColor?: number;
  description?: string;
  housePlanId?: ID;
  jobId?: ID;
}>>;

export type TakeOffParamSharedListItemDto = {
  takeOffParamId: ID;
  code: string;
  isActive: boolean;
};
